export function heroScrollAnimation() {
    const isIE = this.isIE;

    if (!isIE()) {

        setTimeout(() => {
            if (!this.isTouch && this.$window.outerWidth() >= 1200) {
            var scrollIndicator = document.getElementsByClassName("explore-more");
            var headlines = document.getElementsByClassName("fnc-slide__heading-wrap");
                var movement = 0;
                var elements = [];
                var tweenDistance = getRandomArbitrary(200, 400);
                let startIndex = 0;
                let endIndex = 0;

                [...headlines].forEach((line, index) => {
                    var headline = line;
                    // var headlineOffset = headline.offsetTop;
                    var letters = headline.innerText.split("");

                    var newHeadline = document.createElement("span");
                    newHeadline.classList.add("new-headline");

                    letters.forEach(function (letter) {
                        var element = document.createElement("span");
                        element.innerText = letter;
                        element.dataset.speed = Math.random(0, 1).toFixed(2);
                        // headline.appendChild(element);
                        newHeadline.appendChild(element);

                        if (letter !== " " && letter !== "\n") {
                            elements.push(element);
                        }

                    });

                    endIndex = elements.length;
                    this.animatedLetters.push(elements.slice(startIndex, endIndex));
                    startIndex = endIndex;

                    headline.appendChild(newHeadline);
                });

                let activeSlide = document.querySelector("body").getAttribute("data-active-slide");
                let scrolled = window.pageYOffset || window.scrollY;

                this.win.addEventListener("scroll", () => {
                    scrolled = window.pageYOffset || window.scrollY;


                    if (scrolled < window.innerHeight) {
                        var topDistance = window.pageYOffset;
                       // movement = topDistance * 2;

                        activeSlide = document.querySelector("body").getAttribute("data-active-slide");

                        fadeOut(scrollIndicator[0], topDistance, 150);
                        // tweenHeight(scrollIndicatorLine[0], topDistance, 100, 25);

                        this.animatedLetters[activeSlide - 1].forEach(function (element) {

                            if( scrolled > 20){
                                $('.fnc-slider').addClass('scrolled-dw');
                                document.querySelectorAll(".new-headline span").forEach(el => el.style.opacity = '0');
  /*                              document.getElementsByClassName('new-headline')[0].style.opacity = '1';
                                document.getElementsByClassName('new-headline')[1].style.opacity = '1';
                                document.getElementsByClassName('new-headline')[2].style.opacity = '1';
                                document.getElementsByClassName('new-headline')[3].style.opacity = '1';
*/


                                element.style.transition = 'all ' + (element.dataset.speed * 1.75) + 's';
                                var translate3d = "translate3d(0, -300px, 0)";
                                element.style["-webkit-transform"] = translate3d;
                                element.style["-moz-transform"] = translate3d;
                                element.style["-ms-transform"] = translate3d;
                                element.style["-o-transform"] = translate3d;
                                element.style.transform = translate3d;

                            }else{

                                var translate3d = "translate3d(0, 0, 0)";
                                element.style["-webkit-transform"] = translate3d;
                                element.style["-moz-transform"] = translate3d;
                                element.style["-ms-transform"] = translate3d;
                                element.style["-o-transform"] = translate3d;
                                element.style.transform = translate3d;
                            }

                            fadeOut(element, topDistance, tweenDistance);

                        });
                    }

                });



                function getRandomArbitrary(min, max) {
                    return Math.floor(Math.random() * (max - min)) + min;
                }

                function move(element, distance) {
                    if(!$('.fnc-slider').hasClass('slider-scrolled')){

                        printNumbers(0, 200);
                    }
                };

                function moveY(element, distance) {
                    var translate3d = "translateY(" + distance + "%)";
                    element.style["-webkit-transform"] = translate3d;
                    element.style["-moz-transform"] = translate3d;
                    element.style["-ms-transform"] = translate3d;
                    element.style["-o-transform"] = translate3d;
                    element.style.transform = translate3d;
                };

                function fadeOut(element, scrollDistance, tweenDistance) {
                    element.style.opacity = (tweenDistance - scrollDistance) / tweenDistance;
                }

                function tweenHeight(element, scrollDistance, tweenDistance, initialHeight) {
                    element.style.height = (((tweenDistance - scrollDistance) / tweenDistance) * initialHeight) + "px";
                }
            }
        }, 1200);

    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/hero-scroll-animation.js